//Please add the language resource
const settlementClosing = {
  checkoutStatus: 'checkoutStatus',
  checkoutMethod: 'checkoutMethod',
  shipperName: 'shipperName',
  projectName: 'projectName',
  customerOrderNo: 'customerOrderNo',
  soOrSto: 'soOrSto',
  truckNo: 'truckNo',
  orderDate: 'orderDate',
  carrierName: 'carrierName',
  originNo: 'originNo',
  originName: 'originName',
  destNo: 'destNo',
  destName: 'destName',
  destProvince: 'destProvince',
  destCity: 'destCity',
  destDistrict: 'destDistrict',
  destAddress: 'destAddress',
  deliverGoodsTime: 'deliverGoodsTime',
  route: 'route',
  realityReachTime: 'realityReachTime',
  totalQty: 'totalQty',
  totalGrossWeight: 'totalGrossWeight',
  totalVolume: 'totalVolume',
  freight: 'freight',
  upstairsFee: 'upstairsFee',
  terminalCharges: 'terminalCharges',
  valueAddedIncome: 'valueAddedIncome',
  elseIncome: 'elseIncome',
  totalExpense: 'totalExpense',
  remark: 'remark'
};
export default settlementClosing



// WEBPACK FOOTER //
// ./src/page/settlementFee/settlementClosing/lang/settlementClosing.en.js